import { render, staticRenderFns } from "./CouponBtn.vue?vue&type=template&id=9224751e&scoped=true"
import script from "./CouponBtn.vue?vue&type=script&lang=ts"
export * from "./CouponBtn.vue?vue&type=script&lang=ts"
import style0 from "./CouponBtn.vue?vue&type=style&index=0&id=9224751e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9224751e",
  null
  
)

export default component.exports